import React from "react";
import { socialLinks } from "../../../utils";

const Community = () => {
  return (
    <section className=" py-20">
      <div className="container">
        <h2 className="text-center text-[30px] md:text-[44px] font-semibold capitalize">
          join the D3 Protocol <br />{" "}
          <span className="text-primary "> community</span>
        </h2>
        <p className="text-center mx-auto text-gray max-w-md text-base md:text-lg mt-3 ">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut ut massa
          est, pulvinar placerat volutpat aliquet. Nulla habitant.
        </p>
        <div className="grid grid-flow-col justify-center gap-4 md:gap-8 p-4 md:p-6 max-w-xl mx-auto bg-[#161616] mt-8 rounded-2xl">
          {socialLinks.map((val, i) => (
            <a
              href={val.link}
              target="_blank"
              rel="noreferrer"
              className="text-center h-7 md:h-20 w-7 md:w-20 rounded-2xl flex justify-center items-center text-lg md:text-3xl border border-[#262626]"
            >
              {val.icon}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Community;
